// 登录页面接口
import {get,post} from '../utils/request.js'

//获取短信验证码
export const apiGetCodeNum = function (data) {
  return get('index/sendMsg', data);
}

//登录提交--手机验证码登录
export const apiLoginSubmitPhone = function (data) {
  return get('index/login', data);
}

//退出登录
export const apiExitLogin = function (data) {
  return get('index/out', data);
}

//通知 确认提交
export const apiSubmit = function (data) {
  return get('intent/operateIntent', data);
}

//获取隐私政策
export const apiGetPolicy = function (data) {
  return get('home/getPolicy', data);
}

//获取服务协议
export const apiGetAgreement = function (data) {
  return get('home/getAgreement', data);
}

//帮你找房--获取城市列表
export const apiGetCity = function (data) {
  return get('home/getCity', data);
}

//帮你找房--提交
export const apiSunmitOperateIntent = function (data) {
  return get('intent/operateIntent', data);
}

//右侧导航条二维码 电话
export const apigetSetting = function (data) {
  return get('home/getSetting', data);
}



// WEBPACK FOOTER //
// ./src/api/login.js